import { ADD_TAB, SET_ACTIVE_TAB, CLOSE_TAB, CLOSE_ALL_TABS } from "../types/type";

const UPDATE_TAB = "UPDATE_TAB"; // Add this at the top if not already defined

const initialState = {
  tabs: [
    // { title: "Home", path: "/home", contentKey: "home" },
  ],
  activeTab: 0,
};

const tabReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLOSE_ALL_TABS:
      return {
        ...state,
        tabs: [],      // remove all open tabs
        activeTab: 0   // reset to main home
      };
    case ADD_TAB: {
      const existingIndex = state.tabs.findIndex(tab => tab.path === action.payload.path);
      if (existingIndex !== -1) {
        return { ...state, activeTab: existingIndex };
      }
      return {
        ...state,
        tabs: [...state.tabs, action.payload],
        activeTab: state.tabs.length,
      };
    }
    case SET_ACTIVE_TAB:
      return { ...state, activeTab: action.payload };
    case CLOSE_TAB: {
      if (state.tabs.length === 1) return state;
      const newTabs = state.tabs.filter((_, i) => i !== action.payload);
      let newActive = state.activeTab;
      if (state.activeTab >= newTabs.length) newActive = newTabs.length - 1;
      else if (state.activeTab > action.payload) newActive = state.activeTab - 1;
      return { ...state, tabs: newTabs, activeTab: newActive };
    }
    case UPDATE_TAB: {
      // action.payload: { content, updates }
      const { content, updates } = action.payload;
      const updatedTabs = state.tabs.map(tab =>
        tab.content === content ? { ...tab, ...updates } : tab
      );
      return { ...state, tabs: updatedTabs };
    }
    default:
      return state;
  }
}

export default tabReducer;